import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Loader from './PageLoader.style';
import LoaderTexts from './LoaderTexts.json';
import { routesList as routes } from '../../../routes/private.routes';

export default function PageLoader({
  sx,
  loading,
  children,
  showText = true,
  hidePageLoader,
  childrenSx = {},
  pageTitle,
}) {
  const { pathname } = useLocation();
  const selectedTitle = useSelector((state) => state.common.selectedTitle);
  const titleToDisplay =
    pageTitle || selectedTitle || routes?.find((route) => route.path === pathname)?.name;

  const [isFullscreen, setIsFullscreen] = useState(false);
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);
  const newpathname = pathname.split('/')[1];
  const texts = LoaderTexts[newpathname] || LoaderTexts.DEFAULT;

  const [currentText, setCurrentText] = useState(
    texts ? texts[Math.floor(Math.random() * texts.length)] : ''
  );
  useEffect(() => {
    const interval = setInterval(() => {
      if (texts && loading) {
        const randomIndex = Math.floor(Math.random() * texts.length);
        setCurrentText(texts[randomIndex]);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [newpathname, loading]);
  return (
    <Box
      sx={{
        padding: '10px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: 'auto',
        overflow: 'auto',
        px: 2,
        '::WebkitScrollbar': {
          WebkitAppearance: 'none',
          width: '7px',
        },
        '::WebkitScrollbarThumb': {
          borderRadius: '4px',
          backgroundColor: 'rgba(0, 0, 0, .5)',
          boxShadow: '0 0 1px rgba(255, 255, 255, .5)',
        },
        ...sx,
      }}
    >
      {!hidePageLoader && (
        <Box sx={{ display: 'flex', margin: '10px 2px' }}>
          <Typography variant="h5" sx={{ fontSize: '18px' }}>
            {titleToDisplay}
          </Typography>
        </Box>
      )}

      <Box flex={1} overflow="auto" sx={childrenSx}>
        {children}
      </Box>
      {loading && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(1px)',
            zIndex: 99,
          }}
        >
          <Box
            sx={{ fontSize: '1rem' }}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            gap={1}
          >
            {showText ? currentText : 'Loading...'}
            <Loader />
          </Box>
        </Box>
      )}
    </Box>
  );
}
